import React from 'react';
import { Gutter, Layout, WarningIcon } from '@axiom/ui';

import { PALETTE } from '../../themes/constants';

const { grays } = PALETTE;

export type ErrorBlurbProps = {
  errorMessage?: string;
  name?: string;
};

export const ErrorBlurb = ({
  errorMessage = 'An error occurred. Please refresh.',
  name = 'ERROR_BLURB',
}: ErrorBlurbProps) => (
  <Gutter vertical="0.5rem">
    <Layout position="center" name={name}>
      <WarningIcon backgroundColor={grays.black} color={grays.white} />
      <span>{errorMessage}</span>
    </Layout>
  </Gutter>
);
